module.exports = __webpack_public_path__ + "static/media/03_profile_picture.ba6618d4.png";